module.exports = __webpack_public_path__ + "6a0c6dc494a1a3557d8e8201e31670a4.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/BD.svg
// module id = J+Gc
// module chunks = 0